import React from "react";

interface ButtonProps {
  icon?: () => React.ReactNode;
  label?: string | React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  role?: string;
}

/**
 * Button component that supports icons, labels, and various styles
 * @param icon - Optional icon component
 * @param label - Optional button text
 * @param disabled - Whether the button is disabled
 * @param onClick - Click handler
 * @param className - Additional CSS classes for styling
 * @param style - Additional inline styles
 */
export const Button: React.FC<ButtonProps> = ({
  icon,
  label,
  className,
  style,
  onClick,
  onKeyDown,
  role = "button",
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.();
    }
    onKeyDown?.(e);
  };

  return (
    <button
      type="button"
      role={role}
      className={`flex items-center ${className}`}
      style={style}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      {icon && icon()}
      {label}
    </button>
  );
};

export default Button;
